(function () {
  var failTimer;

  function showElements() {
    document.querySelectorAll('[id$="-videowise"]').forEach(function (el) {
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    });
  }

  function hideElements() {
    document.querySelectorAll('[id$="-videowise"]').forEach(function (el) {
      el.style.visibility = 'hidden';
      el.style.opacity = '0';
    });
  }

  function removeElements() {
    document.querySelectorAll('[id$="-videowise"]').forEach(function (el) {
      el.remove();
    });
  }

  function applyThumbnail() {
    var vwImage = document.querySelector('#vw-root img');
    if (!vwImage) return false;
    var src = vwImage.getAttribute('src');
    if (!src) return false;
    var alt = vwImage.getAttribute('alt') || 'Videowise';
    document.querySelectorAll('[id^="Slide-Thumbnails-"][id$="-videowise"] button').forEach(function (btn) {
      if (!btn.querySelector('img')) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = alt;
        img.loading = 'lazy';
        btn.textContent = '';
        btn.appendChild(img);
      }
    });
    showElements();
    clearTimeout(failTimer);
    return true;
  }

  function waitForVideowise() {
    if (applyThumbnail()) return;
    var observer = new MutationObserver(function () {
      if (applyThumbnail()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideElements();
    failTimer = setTimeout(removeElements, 5000);
    waitForVideowise();
  });
})();
